export const headers = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};